export default {
  computed: {
    schemaEvaluasiPelaksanaan() {
      return [
        {
          title: '',
          key: 'smk-iht',
        },
        {
          title:
            'Menurut Anda, bagaimana kesesuaian durasi waktu untuk setiap materi? Sesuaikan dengan materi IHT (15 Materi)',
          key: 'smk-iht-1',
          model: 'table',
        },
        {
          title: 'Menurut Anda, materi apa saja yang masih membutuhkan penguatan dari segi substansi materi?',
          key: 'smk-iht-2',
          model: 'table',
        },
        {
          title: '',
          key: 'smk-iht-3',
        },
        {
          title: 'Menurut Anda, materi apa saja yang masih membutuhkan penguatan dari segi substansi materi?',
          key: 'smk-iht-4',
          model: 'table',
        },
        {
          title: '',
          key: 'smk-iht-5',
        },
      ];
    },
  },
};
